import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {tabletAndUpLinaria} from '../../../constants/customMedia';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {Heading16} from '../../atoms/Text/Headings';

export const SliderControl = styled(Heading16)`
  color: ${COLORS.Black};
  display: flex;
  align-items: center;
  display: none;

  [data-theme='dark'] & {
    color: ${COLORS.White};
  }

  ${tabletAndUpLinaria('display: flex;')};
`;

export const SlideControlText = styled.span`
  text-align: center;
  min-width: 30px;
  display: inline-block;
`;

export const SlideControlArrowStart = styled.span`
  width: 7px;
  padding: 10px 16px;
  background-position: center center;
  transition: transform 75ms ease-in-out;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  color: ${COLORS.Grey2};
  transform: rotate(180deg);
  cursor: pointer;

  &[data-disabled='true'] {
    cursor: default;

    svg {
      fill: ${COLORS.Grey2};
    }
  }

  [data-theme='dark'] & {
    svg {
      fill: ${COLORS.White};
    }

    &[data-disabled='true'] {
      svg {
        fill: ${COLORS.Grey1};
      }
    }
  }

  :active {
    transform: rotate(180deg) translateX(-1px) scale(0.9);
  }
`;

export const SlideControlArrowEnd = styled(SlideControlArrowStart)`
  transform: translateX(-1px);
  :active {
    transform: scale(0.9);
  }
`;

interface Props {
  prev: () => void;
  next: () => void;
  currentPage: number;
  maxPages: number;
  prevIsActive: boolean;
  nextIsActive: boolean;
}

export const HorizontalSliderControl: FC<Props> = ({
  prev,
  next,
  currentPage,
  maxPages,
  prevIsActive,
  nextIsActive,
}) => {
  return (
    <SliderControl data-testid="HorizontalSliderControl">
      <SlideControlArrowStart
        data-testid="SlideControlArrowStart"
        onClick={prev}
        data-disabled={!prevIsActive}
      >
        <Icon size="XS" asset={GenericIconName.ArrowRight} />
      </SlideControlArrowStart>
      <SlideControlText data-testid="SlideControlText">
        <span>{currentPage}</span>/<span>{maxPages}</span>
      </SlideControlText>
      <SlideControlArrowEnd
        data-testid="SlideControlArrowEnd"
        onClick={next}
        data-disabled={!nextIsActive}
      >
        <Icon size="XS" asset={GenericIconName.ArrowRight} />
      </SlideControlArrowEnd>
    </SliderControl>
  );
};
